import { ref } from 'vue';

/**
 * useUpgradeOverlay — el estado ÚNICO de la capa de upsell (`UpgradeOverlay`).
 *
 * Por qué existe: el estado vivía dentro de `AppSidebar.vue`, y la capa se abría
 * con un handler en fase de captura sobre SU `<nav>`. O sea que solo los items
 * con candado del sidebar abrían el modal; todo el resto —el "My Networks"
 * bloqueado del header, los estados bloqueados de las fichas de tour, los CTA
 * del journey de launchpad, el reporte de plan— hacía `router.push` a la página
 * `/upgrade`, que monta su propio nav y te expulsa de la aplicación. Dos
 * experiencias distintas para el mismo upsell según por dónde entraras.
 *
 * El `ref` se declara a nivel MÓDULO, no adentro de la función: así todos los
 * consumidores comparten la misma instancia y cualquier punto de la app abre la
 * misma capa. Un `ref` dentro de la función daría un estado por consumidor.
 *
 * La ruta `/upgrade` sigue viva: los links con candado conservan su `href` real,
 * así que ctrl-click / abrir en pestaña nueva y los deep links no se rompen. Lo
 * único que se intercepta es el click normal.
 */

const isOpen = ref(false);

export function useUpgradeOverlay() {
  const openUpgrade = () => { isOpen.value = true; };
  const closeUpgrade = () => { isOpen.value = false; };

  /**
   * Handler para links con candado que conservan su `href` a `/upgrade`.
   * Los modificadores y el botón del medio siguen siendo navegación de verdad:
   * quien quiera la página en otra pestaña la abre igual.
   */
  const onLockedClick = (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    openUpgrade();
  };

  return { isOpen, openUpgrade, closeUpgrade, onLockedClick };
}
